export { CookiesProvider, useCookies } from "react-cookie";

export const LOYALTY_COOKIE_NAME = "loyalty";
